import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../../../lang/LangEnum';
import { Prices } from '../interfaces/productPricesTooltip.interfaces';
import ProductPricesV2 from './ProductPricesV2';

interface ProductPricesModalProps {
  isOpen: boolean;
  onClose: () => void;
  prices: Prices[];
  hasPriceVariation: boolean;
}

const ProductPricesModal = ({
  isOpen,
  onClose,
  prices,
  hasPriceVariation,
}: ProductPricesModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="expanded"
      header={{ title: LangEnum.PRODUCT_PRICES_VARIATION_BY_SIZE }}
    >
      <ProductPricesV2 prices={prices} hasPriceVariation={hasPriceVariation} />
    </Modal>
  );
};

export default ProductPricesModal;
